import { render, staticRenderFns } from "./TimeSelector.vue?vue&type=template&id=60f55bfc"
import script from "./TimeSelector.vue?vue&type=script&lang=js"
export * from "./TimeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f55bfc')) {
      api.createRecord('60f55bfc', component.options)
    } else {
      api.reload('60f55bfc', component.options)
    }
    module.hot.accept("./TimeSelector.vue?vue&type=template&id=60f55bfc", function () {
      api.rerender('60f55bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TimeSelector.vue"
export default component.exports